const stations = [
    { name: 'Alytus', value: 102 },
    { name: 'Biržai  ', value: 134 },
    { name: 'Šakiai', value: 144 },
    { name: 'Šalčininkai', value: 124 },
    { name: 'Šiauliai', value: 113 },
    { name: 'Druskininkai', value: 112 },
    { name: 'Jonava', value: 116 },
    { name: 'Joniškis', value: 142 },
    { name: 'Jurbarkas', value: 132 },
    { name: 'Kaunas', value: 101 },
    { name: 'Kėdainiai', value: 103 },
    { name: 'Kelmė', value: 137 },
    { name: 'Klaipėda', value: 105 },
    { name: 'Kupiškis', value: 131 },
    { name: 'Kuršėnai', value: 135 },
    { name: 'Marijampolė', value: 136 },
    { name: 'Mažeikiai', value: 110 },
    { name: 'Naujoji Akmenė', value: 125 },
    { name: 'Pakruojis', value: 143 },
    { name: 'Palanga', value: 128 },
    { name: 'Panevėžys', value: 108 },
    { name: 'Pasvalys', value: 107 },
    { name: 'Plungė', value: 139 },
    { name: 'Prienai', value: 104 },
    { name: 'Radviliškis', value: 133 },
    { name: 'Raseiniai', value: 122 },
    { name: 'Rokiškis', value: 119 },
    { name: 'Skuodas', value: 127 },
    { name: 'Tauragė', value: 121 },
    { name: 'Telšiai', value: 130 },
    { name: 'Ukmergė', value: 118 },
    { name: 'Utena', value: 141 },
    { name: 'Varėna', value: 129 },
    { name: 'Vilkaviškis', value: 115 },
    { name: 'Vilnius', value: 106 }
]

export default stations
